import request from "@/utils/request";

// 获取申请列表
export function getApplicationPagesByCondition(params) {
  return request({
    url: "/cloud/application/getPagesByCondition",
    method: "post",
    data: params
  });
}

// 获取申请信息
export function getApplicationById(id) {
  return request({
    url: "/cloud/application/info?applicationId=" + id,
    method: "get"
  });
}

// 提交道路测试申请
export function testApplication(data) {
  return request({
    url: "/cloud/application/apply",
    method: "post",
    data: data
  });
}

// 获取提交道路测试申请表单的数据
export function getTestApplication(id) {
  return request({
    url: "/cloud/application/testApplication?id=" + id,
    method: "get"
  });
}
